
export const CLOSE_SMART_BANNER = 'CLOSE_SMART_BANNER';

export type SmartAppBannerActionType = { type: typeof CLOSE_SMART_BANNER; payload: boolean; };

export const onBannerClose = (): SmartAppBannerActionType => ({
    type: CLOSE_SMART_BANNER,
    payload: true
});

export type SmartAppBannerActions = ReturnType<typeof onBannerClose>;